namespace OfficeGuy {
    export class SortedTable {
        public static StaticBindEvents(): void {
            $(document)
                .on("click", ".sortedtable-header", function (Event) {
                    SortedTable.Sort($(this));
                });
        }
        public static PageLoad(): void {
            $(".sortedtable-state").each(function() {
                var $Table = $(this);
                var $Input = $($Table.data("sortinput"));
                if (!$Input.val())
                    return;
                var Index = Number($Input.val());
                SortedTable.Sort($($Table.find("thead th")[Math.abs(Index)]), Index < 0);
            });
        }

        static Sort($HeaderCell, Descending?) {
            var Index = $HeaderCell.index();

            if (Descending == null) {
                if ($HeaderCell.find(".icon-up").length > 0)
                    Descending = true;
                else if ($HeaderCell.find(".icon-down").length > 0)
                    Descending = false;
                else
                    Descending = $HeaderCell.hasClass("sortedtable-header-descending");
            }
            $HeaderCell.closest('tr').find('span.icon-down, span.icon-up').remove();
            $(".og-books-batch thead th span.icon-down").remove();
            $HeaderCell.append($(document.createElement('span'))
                .addClass(Descending ? "icon-down" : "icon-up")
            );

            var GetCellValue = function (Row) {
                var $Cell = $(Row).children('td').eq(Index);
                var ToReturn = $Cell.data("sortkey");
                if (!ToReturn)
                    ToReturn = $Cell.text();
                return ToReturn;
            }

            var $Table = $HeaderCell.closest('table');
            var $Body = $Table.find('tbody');
            var Rows = $Body.find('tr').toArray().sort(function (a, b) {
                var valA = GetCellValue(a);
                var valB = GetCellValue(b);
                return $.isNumeric(valA) && $.isNumeric(valB) ? Number(valA) - Number(valB) : valA.toString().localeCompare(valB)
            });
            if (Descending)
                Rows = Rows.reverse();
            for (var i = 0; i < Rows.length; i++)
                $Body.append(Rows[i]);
            if ($Table.hasClass("sortedtable-state")) {
                var $Input = $($Table.data("sortinput"));
                $Input.val((Descending ? -Index : Index).toString());
            }

            return false;
        }
    }
}

$(document).on("Teva.Init", function () {
    OfficeGuy.SortedTable.StaticBindEvents();
});
$(document).on("Teva.PageLoad", function () {
    OfficeGuy.SortedTable.PageLoad();
});